import React, { Fragment, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '@/assets/app/css/quizResult.module.css';
import FrameBox from '@/shared/components/ui/new/FrameBox';
import StarImage from '@/assets/app/images/adventure/icon_star.png';
import StarEmptyImage from '@/assets/app/images/adventure/icon_empty_star.png';
import CompleteBearImage from '@/assets/app/images/common/bottom/complete-bear.png';
import AppButton from '@/shared/components/ui/new/AppButton';
import useBottomSheetStore from '@/shared/store/UseBottomSheetStore';

interface QuizAnswer {
  questionNumber: number;
  userAnswer: 'correct' | 'incorrect';
  type: 'O' | 'X';
}

interface QuizResultProps {
  completedData: QuizSessionResult;
  chapter?: ChapterData;
  session: QuizSession;
  retryQuiz: Function;
}

const QuizResultDetail: React.FC<QuizResultProps> = ({
  completedData,
  session,
  chapter,
  retryQuiz,
}) => {
  const [showResult, setShowResult] = useState(false);
  const { openSheet } = useBottomSheetStore();

  const endAdventure = () => {
    window.location.reload();
  };

  const openRetryQuiz = () => {
    openSheet('retry-quiz', { onConfirm: retryQuiz, onCancel: endAdventure });
  };

  const openQuizResult = () => {
    openSheet('quiz-result', {
      completedData: completedData,
      onConfirm: retryQuiz,
      onCancel: endAdventure,
      title: '결과 확인',
      showHeader: true,
    });
  };

  return (
    <Fragment>
      <div className="quiz-container" style={{ borderTop: '5px solid var(--color-btn)' }}>
        <header className="grid grid-cols-[1fr_auto_1fr] items-center w-full mb-[15px] px-4 py-2 bg-white">
          {/* 1. 왼쪽: 뒤로가기 버튼 영역 (왼쪽 정렬) */}
          <div className="flex justify-start">
            <button className="btn-back-theme f-one-pop" onClick={endAdventure}>
              모험종료
            </button>
          </div>

          {/* 2. 가운데: 타이틀 영역 (양쪽 버튼 크기와 상관없이 항상 정중앙 고정) */}
          <div className="text-center quiz-title">{chapter?.personName}</div>

          {/* 3. 오른쪽: 챕터 표시 영역 (오른쪽 정렬) */}
          <div className="flex justify-end">
            <span className="text-[14px] font-medium" style={{ color: 'var(--color-btn-border)' }}>
              {chapter?.chapterTitle}
            </span>
          </div>
        </header>
        <div className="px-4">
          <div className="page-indicators">
            {[...Array(chapter?.questionCount)].map((_, index) => (
              <div
                key={index}
                className="indicator w-[10px] h-[10px]"
                style={{
                  backgroundColor: 'var(--color-btn)',
                }}
              />
            ))}
          </div>

          <div className="text-[26px] font-[800] text-center mt-2">
            {session.isRetry ? '다시하기 완료!' : '오늘의 모험 완료!'}
          </div>

          <FrameBox
            style={{
              margin: '30px auto',
              fontSize: 20,
              padding: '30px 10px 0',
              display: 'flex',
              minHeight: 150,
              justifyContent: 'center',
              backgroundColor: 'white',
            }}
          >
            {/* @TODO 다시 하기 시 별 포인트 추가? */}
            {/* {!session.isRetry && ( */}
            <>
              <div className="flex justify-center gap-1">
                {Array.from({ length: completedData.correctAnswers }).map((_, index) => (
                  <img src={StarImage} />
                ))}
                {Array.from({
                  length: completedData.totalQuestions - completedData.correctAnswers,
                }).map((_, index) => (
                  <img src={StarEmptyImage} />
                ))}
              </div>
              <div className="text-[20px] text-[#14A1C8] text-center mt-7">
                <span className=" font-[800]">별 포인트 {completedData.earnedPoints}개</span>를
                획득했습니다
              </div>
            </>
            {/* )} */}
          </FrameBox>

          <div className="bottom-btn-group">
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
              <img src={CompleteBearImage} style={{ maxWidth: 'max-content' }} />
            </div>
            <AppButton
              className="f-one-pop text-[20px]"
              onConfirm={openQuizResult}
              message="결과 확인"
            />
            <AppButton
              className="f-one-pop text-[20px]"
              backgroundColor="#D4D4D4"
              boxShadowColor="#B7B7B7"
              style={{
                marginTop: 10,
              }}
              onConfirm={openRetryQuiz}
              message="다시 하기"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default QuizResultDetail;
